import React from "react";
import { decodeToken } from "react-jwt";
import { useLoginContext } from "../../context/loginContext";

const JWT = () => {

    const { loginContext } = useLoginContext();

    return (
        <div style={{ padding: '1rem' }}>
            {loginContext &&
                <table>
                    <tbody>
                        {Object.keys(decodeToken(loginContext.syswebapp)).map(key => {
                            return (
                                <tr key={key}>
                                    <td style={{ paddingRight: '.5rem' }}>{key}</td>
                                    <td> : {decodeToken(loginContext.syswebapp)[key]}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            }

            {!loginContext &&
                <div>{JSON.stringify(loginContext)}</div>
            }
        </div>
    )
}

export default JWT;